export const PENT_TOOL_COLOR = [
    "#000000",
    "#f24822",
    "#ffa629",
    "#ffcd29",
    "#14ae5c",
    "#0d99ff",
    "#9747ff",
    "#ffffff",
];

export const PEN_TOOL_LINE_WIDTH = [3, 6, 11];

export const PEN_TOOL_MODES = ["pen", "highlighter", "eraser"];
